<app-incident-filters 
[params]="_params" 
[customButton1Text]="'Crear Comunicado'" 
(onCustomButton1)="createStatement()"
[customButton5Text]="'Acciones'" 
(onCustomButton5)="actionEvents($event)"
[customButton5Disabled]="!selectedRowList.length"
[customButton5Tooltip]="!selectedRowList.length? 'Selecciona al menos un comunicado para habilitar las acciones' : 'Selecciona una acción para los comunicados seleccionados.'"
[enabledDropdownButton]="true"
[enableExportButton]="true"
[menuButtonList]="menuFilterButtonList"
(onActionBtnList)="actionEvents($event)"
></app-incident-filters>

<div id="selected-incident" class="alert alert-secondary mb-0" *ngIf="selectedRowList.length && tableConfig?.Elements?.length">
  <p class="d-inline-block mb-0">Seleccionados: <span class="ml-1">{{selectedRowList.length}}</span></p> 
</div>

<app-custom-table 
[data]="tableConfig" 
[enablePagination]="true" 
[enableRowsPerPage]="true"
[enableCheckSelected]="true"
[loadData]="loadCommunication === 1 ?  true : false"
[warningTooltipText]="'Este comunicado no está asociado a ningún evento. Usa la opción ¨Asociar o Crear Evento¨ para continuar.'"
[menuButtonList]="menuTableButtonList"
(onSelectedRowList)="rowSelectedList($event)">
</app-custom-table>

<app-incident-management-modal
  #communicationModal
  (onClose)="onCloseSettings($event)"
  [data]="communicationElements ? communicationElements : null"
  (dataChange)="saveDataElements($event)"
></app-incident-management-modal>
